import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const FILTER_KEY = 'quick_filter_brand';

export const useQuickFilterSectionBrandOpenedState = () => {
  return useOpenedStateManager(FILTER_KEY);
};
